// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2pnLU","alert":"SettungsInbox_alert__25EOP"};